import {Component, Input} from '@angular/core';
import {CartService} from "../../../core/services/cart.service";
import {Router} from "@angular/router";
import { Platform } from '@angular/cdk/platform';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent {
  @Input() product:any;
  @Input() cartEnabled: boolean = false;
  selectedItem = 0;
  wordLimit = 25;
  viewSimilar: boolean = false;

  constructor(private cartService: CartService, private router: Router, private platform: Platform) {
    this.wordLimit = !this.platform.ANDROID ? this.wordLimit : 35;
  }

  calculateDiscount(item: any) {
    if (item.mrp && item.mop) {
      const discount = Math.round(((item.mrp - item.mop) / item.mrp) * 100);
      return parseFloat(discount.toFixed(2))+'% off';
    }
    return 0;
  }

  addToCart(product:any) {
    let item = product.items[this.selectedItem];
    item['itemId'] = item.item_id;
    this.cartService.addToCart(item);
  }

  navigateURL(product: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/product/${product.catalogId}`]);
    });
    //this.router.navigateByUrl(`/product/${product.catalogId}`);
  }

  modifyTitle(title: string) {
    return (screen.width > 767 && title.length > this.wordLimit) ? title.substring(0, this.wordLimit)+'...' : title;
  }
}
